import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "ngp_jwt";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach bearer token from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Public
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const requestNda = (payload) => api.post("/nda/request", payload).then((r) => r.data);

// Auth
export const authLogin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => {
    localStorage.setItem(TOKEN_KEY, r.data.access_token);
    return r.data;
  });
export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const authLogout = () => {
  const t = localStorage.getItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_KEY);
  if (!t) return Promise.resolve({ ok: true });
  return api.post("/auth/logout", {}, { headers: { Authorization: `Bearer ${t}` } })
    .then((r) => r.data).catch(() => ({ ok: true }));
};
export const authHasToken = () => Boolean(localStorage.getItem(TOKEN_KEY));

// Admin (Bearer via interceptor)
export const listSubmissions = () => api.get("/admin/submissions").then((r) => r.data);
export const deleteSubmission = (id) => api.delete(`/admin/submissions/${id}`).then((r) => r.data);
export const listNdaRequests = () => api.get("/admin/nda-requests").then((r) => r.data);
export const deleteNdaRequest = (id) => api.delete(`/admin/nda-requests/${id}`).then((r) => r.data);
export const revokeNdaRequest = (id) => api.post(`/admin/nda-requests/${id}/revoke`).then((r) => r.data);
export const unrevokeNdaRequest = (id) => api.post(`/admin/nda-requests/${id}/unrevoke`).then((r) => r.data);
export const pressStats = () => api.get("/admin/press-stats").then((r) => r.data);
export const libraryIndex = () => api.get("/admin/library").then((r) => r.data);
export const libraryDetail = (id) => api.get(`/admin/library/${id}`).then((r) => r.data);

// Press
export const pressUrls = {
  logoLight: `${API}/press/logo-light.svg`,
  logoDark: `${API}/press/logo-dark.svg`,
  factSheet: `${API}/press/fact-sheet.pdf`,
};
